document.addEventListener('DOMContentLoaded', () => {
  const addEventListenerForKubunSelect = (kubunSelect) => {
    kubunSelect?.addEventListener('change', (event) => {
      if (event.target.value === 'parttime') {
        const taxTableKou = document.getElementById(
          `company_users_attributes_${event.target.dataset.key}_tax_table_kou`
        );

        taxTableKou.removeAttribute('checked');
        taxTableKou.checked = false;

        const taxTableOtsu = document.getElementById(
          `company_users_attributes_${event.target.dataset.key}_tax_table_otsu`
        );

        taxTableOtsu.setAttribute('checked', 'checked');
        taxTableOtsu.checked = true;
      }
    });
  };

  const addEventListenerForKubunSelects = () => {
    const kubunSelects = document.querySelectorAll(
      'select[id^="company_users_attributes_"][id$="_kubun"]'
    );

    kubunSelects.forEach((kubunSelect) => {
      addEventListenerForKubunSelect(kubunSelect);
    });
  };

  const addUserRegisterForm = document.getElementById('add-user-register-form');

  addUserRegisterForm?.addEventListener('click', () => {
    const kubunSelects = document.querySelectorAll(
      'select[id^="company_users_attributes_"][id$="_kubun"]'
    );
    const lastChild = kubunSelects[kubunSelects.length - 1];

    addEventListenerForKubunSelect(lastChild);
  });

  addEventListenerForKubunSelects();
});
